import React, {useEffect} from "react";
import Header from "./components/Header";

const Home = () => {
    const body = document.querySelector('body');
    const style = {
        "height": "calc(100vh - 70px)",
        "overflow": "hidden"
    }

    useEffect(() => {body.style.paddingTop = "70px";}, [body.style]);

    return (
        <div style={style}>
            <Header/>
            <img className="hero" src="https://dvqlxo2m2q99q.cloudfront.net/000_clients/727777/page/727777LUc8QtIH.jpg" alt="wizualizacja lotniska" />
        </div>
    );
}

export default Home;